// Imports
// React
import React from 'react';

interface ThankYouMessageProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

// Component Definition
export const ThankYouMessage: React.FC<ThankYouMessageProps> = ({ className = '', ...props }) => {
  return (
    <div
      className={`mx-auto w-full max-w-2xl rounded-xl bg-white/10 p-8 backdrop-blur-sm ${className}`}
      role="status"
      aria-live="polite"
      {...props}
    >
      {/* Success Icon */}
      <div className="mb-6 flex justify-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-r from-green-400 to-green-600 shadow-lg">
          <svg
            className="h-8 w-8 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
          </svg>
        </div>
      </div>

      {/* Heading */}
      <h2 className="mb-4 text-3xl font-bold text-white antialiased">You&apos;re on the list!</h2>

      {/* Description */}
      <p className="text-lg leading-relaxed text-gray-200 antialiased">
        We&apos;ll email you soon to learn about your booking challenges and give you early access.
      </p>
    </div>
  );
};
